import { render, staticRenderFns } from "./IECstatistics.vue?vue&type=template&id=0bcdabd8&scoped=true&"
import script from "./IECstatistics.vue?vue&type=script&lang=js&"
export * from "./IECstatistics.vue?vue&type=script&lang=js&"
import style0 from "./IECstatistics.vue?vue&type=style&index=0&id=0bcdabd8&scoped=true&lang=css&"
import style1 from "./IECstatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdabd8",
  null
  
)

export default component.exports